import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import api from "../../../services/api";

export default function Chat({ user, setUser }) {
  const [chatMessage, setChatMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [isLoadingChat, setIsLoadingChat] = useState(false);

  const currentUser = useSelector((state) => state.Auth.user);

  useEffect(() => {
    if (!user?._id) return;
    getMessages();
  }, [user]);

  async function getMessages() {
    try {
      const { data, ok } = await api.post("/meeting_message/search", { user_id: user._id, sortby: "-createdAt", limit: 100 });
      if (!ok) return toast.error(data.error);
      setMessages(data);
    } catch (error) {
      toast.error("Erreur lors du chargement des messages");
    }
  }

  async function addMessage(message) {
    try {
      const { ok } = await api.post("/meeting_message", {
        text: message,
        user_id: user._id,
        user_name: user.name,
        user_avatar: user.avatar,
        author_id: currentUser._id,
        author_name: currentUser.name,
        author_avatar: currentUser.avatar,
      });
      if (!ok) return toast.error("Erreur lors de la sauvegarde");
      await getMessages();
      toast.success("Message sauvegardé");
    } catch (error) {
      toast.error("Erreur lors de la sauvegarde");
    }
  }

  async function handleIaChat() {
    if (!chatMessage.trim() || isLoadingChat) return;

    const userMessage = chatMessage.trim();
    setChatMessage("");
    setIsLoadingChat(true);

    try {
      await addMessage(userMessage);

      const { ok } = await api.post("/meeting_message/chat", {
        message: userMessage,
        user_id: user._id,
        user_name: user.name,
        user_avatar: user.avatar,
        author_name: "IA",
      });

      if (!ok) {
        toast.error("Erreur lors de la communication avec Claude");
        return;
      }

      await getMessages();
    } catch (error) {
      console.error("Chat error:", error);
      toast.error("Erreur lors de la communication avec Claude");
    } finally {
      setIsLoadingChat(false);
    }
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <span className="text-blue-600">🤖</span>
        Claude Chat
      </h2>

      <div className="mb-4 max-h-[600px] overflow-y-auto border rounded-lg p-4 bg-gray-50">
        <div className="space-y-3">
          {messages.map((message) => (
            <div key={message.id} className={`flex ${message.author_name !== "IA" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-xs lg:max-w-md px-3 py-2 rounded-lg ${message.author_name !== "IA" ? "bg-blue-600 text-white" : "bg-white text-gray-800 border"}`}>
                <div className="text-sm whitespace-pre-wrap">{message.text}</div>
              </div>
            </div>
          ))}
          {isLoadingChat && (
            <div className="flex justify-start">
              <div className="bg-white text-gray-800 border px-3 py-2 rounded-lg">
                <div className="flex items-center gap-2">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                  <span className="text-sm">Claude réfléchit...</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="flex gap-2">
        <textarea
          value={chatMessage}
          onChange={(e) => setChatMessage(e.target.value)}
          placeholder="Posez votre question à Claude..."
          className="flex-1 p-2 border rounded-md resize-none"
          rows={2}
          disabled={isLoadingChat}
        />
        <button
          onClick={handleIaChat}
          disabled={isLoadingChat || !chatMessage.trim()}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
          {isLoadingChat ? "..." : "Send"}
        </button>
      </div>
    </div>
  );
}
